import React from "react";
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header pt-5 pt-md-8">
        <Container fluid></Container>
      </div>
    </>
  );
};

export default Header;
